<div class="eml-viewer" [class.loading]="isLoading" [class.error-state]="!!error">

  <!-- Loading -->
  <div *ngIf="isLoading" class="splash loading">
    <p>{{ getRessource('Loading') }}</p>
  </div>

  <!-- Error -->
  <div *ngIf="error && !isLoading" class="state-overlay error">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <span>{{ error }}</span>
  </div>

  <!-- Email Content -->
  <ng-container *ngIf="email && !isLoading && !error">

    <!-- Header Card -->
    <div class="email-header">
      <div class="subject-row">
        <h1 class="subject">{{ email.subject || '(Kein Betreff)' }}</h1>
        <span class="date">{{ email.date | date:'dd.MM.yyyy HH:mm' }}</span>
      </div>

      <div class="meta-grid">
        <div class="meta-row" *ngIf="email.from">
          <span class="meta-label">Von</span>
          <span class="meta-value">{{ email.from }}</span>
        </div>
        <div class="meta-row" *ngIf="email.to">
          <span class="meta-label">An</span>
          <span class="meta-value">{{ email.to }}</span>
        </div>
        <div class="meta-row" *ngIf="email.cc">
          <span class="meta-label">CC</span>
          <span class="meta-value">{{ email.cc }}</span>
        </div>
        <div class="meta-row" *ngIf="email.bcc">
          <span class="meta-label">BCC</span>
          <span class="meta-value">{{ email.bcc }}</span>
        </div>
      </div>

      <!-- Attachments Bar -->
      <div class="attachments-bar" *ngIf="email.attachments.length > 0">
            <span class="attach-count">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
              </svg>
              {{ email.attachments.length }} {{ email.attachments.length == 1 ? 'Anhang' : 'Anhänge' }}
            </span>
        <div class="attach-chips">
          <a
            *ngFor="let att of email.attachments"
            class="attach-chip"
            [href]="att.safeUrl"
            [download]="att.filename"
            [title]="att.filename + ' (' + formatSize(att.size) + ')'"
          >
            <span class="chip-icon">{{ getFileIcon(att.contentType) }}</span>
            <span class="chip-name">{{ att.filename }}</span>
            <span class="chip-size">{{ formatSize(att.size) }}</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Body Tabs -->
    <div class="body-tabs" *ngIf="email.htmlBody && email.textBody">
      <button [class.active]="activeTab === 'html'" (click)="activeTab = 'html'">HTML</button>
      <button [class.active]="activeTab === 'text'" (click)="activeTab = 'text'">Plain Text</button>
    </div>

    <!-- HTML Body -->
    <div class="email-body html-body"
         *ngIf="(activeTab === 'html' || !email.textBody) && email.htmlBody">
      <div [innerHTML]="email.htmlBody"></div>
    </div>

    <!-- Plain Text Body -->
    <div class="email-body text-body"
         *ngIf="(activeTab === 'text' || !email.htmlBody) && email.textBody">
      <pre>{{ email.textBody }}</pre>
    </div>

    <!-- Empty -->
    <div class="email-body empty-body" *ngIf="!email.htmlBody && !email.textBody">
      <p>Kein Nachrichteninhalt vorhanden.</p>
    </div>

  </ng-container>
</div>
